<template>
  <menu-dropdown
    class="main-menu-grouping-mobile-dropdown"
    :open="store.mobile.menuGroupingOpen"
    :top="store.mobile.menuGroupingTop"
    :items="tabsLayout"
    dropdown-class="main-menu-grouping-mobile-dropdown__menu-item-list"
    @click-outside="handleClickOutside"
  >
    <template #select="{ props }">
      <menu-item
        v-bind="props"
        key="mainSelect"
        class="main-menu-grouping-mobile-dropdown__select"
        :title="activeItem.title"
        :icon="activeItem.icon"
        :decorative-dropdown="true"
        @click="handleMainSelectClick"
      />
    </template>

    <template #item="tab">
      <menu-item
        v-if="tab.showCondition"
        :key="tab.key"
        :title="tab.title"
        :icon="tab.icon"
        :dropdown="!!tab.subItems"
        :selectable="true"
        :selected="tab.active"
        :value="(tab.subItems && tab.active) || null"
        @click="handleAction(tab, $event)"
      >
        <template v-if="!!tab.subItems">
          <menu-item
            v-for="data in tab.subItems"
            :key="data.key"
            :title="data.title"
            :icon="data.icon"
            :selectable="true"
            :selected="data.active"
            @click="handleAction(data, $event)"
          />
        </template>
      </menu-item>
    </template>
  </menu-dropdown>
</template>

<script setup lang="ts">
import { useStore } from '@/store';
import MenuItem from '@/components/menu/menu-item.vue';
import MenuDropdown from '@/components/menu-dropdown.vue';
import { useMainMenuGrouping } from '@/composables';
import type { MainMenuLayoutTab } from '@/composables/useMainMenuGrouping';

const store = useStore();
const { tabsLayout, activeItem } = useMainMenuGrouping();

const close = () => {
  store.setMenuGroupingOpen(false);
};

const handleMainSelectClick = () => {
  close();
};

const handleAction = (tab: MainMenuLayoutTab, event: MouseEvent) => {
  if (tab.click) {
    tab.click(event);
  }

  if (!tab.subItems) {
    close();
  }
};

const handleClickOutside = () => {
  if (store.mobile.menuGroupingOpen) {
    close();
  }
};
</script>

<style lang="scss">
.main-menu-grouping-mobile-dropdown {
  position: absolute;
  z-index: 999;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;

  &__delimiter {
    height: 40px;
    border-bottom: 1px solid var(--color-white);
  }

  &__menu-item-list {
    overflow-y: auto;
    flex-grow: 1;
    flex-shrink: 1;
  }

  .menu-list-item {
    background-color: var(--color-white);
    color: var(--color-graphite);
    border-bottom: none;
  }

  .menu-list-item__content:hover {
    color: var(--color-green);
  }

  .menu-list-item__dropdown-body {
    .menu-list-item {
      background-color: var(--color-gray5);
    }
  }

  .menu-list-item--selected,
  .menu-list-item--dropdown-collapsed {
    color: var(--color-green);
  }

  .menu-list-item--dropdown-collapsed {
    &::before {
      content: '';
      position: absolute;
      width: 4px;
      height: 100%;
      background-color: var(--color-green);
    }
  }

  &__select {
    flex-grow: 0;
    padding-top: 1px;

    &.menu-list-item {
      color: var(--color-graphite);
      background-color: var(--color-green10);

      &::before {
        content: none;
      }
    }
  }
}
</style>
